import { User } from 'types/User';

import api from 'utils/api';

export const getUsersForDutiesFeature = () => api.get<User[]>(`duties/users`);
